import React, { useState } from "react";
import SidebarMenuItem from "./SidebarMenuItem";
import { classNames } from "../../helpers/classNames";

const SidebarMenuBlocks = ({ divClasses, menuTitle, menuData, isMenuOpen, ...props }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <>
      <div className={classNames("relative transition-all duration-100", divClasses)}>
        <div
          className={classNames(
            "transition-all duration-200 overflow-hidden",
            !isExpanded || !menuTitle ? "" : "max-h-0"
          )}
        >
          <div className="space-y-1 flex flex-col items-center justify-center">
            {menuData?.map((item, i) => (
              <SidebarMenuItem
                key={item?._id + i}
                menuLink={item.menuLink}
                menuIcon={item.menuIcon}
                menuIconColor={item.menuIconColor}
                menuLabel={item.menuLabel}
                isMenuOpen={isMenuOpen}
                blank={item?.blank}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default SidebarMenuBlocks;
